// Copyright (c) 2017 Deere & Company

import actions from '../actions-list';
import {addRemoveModalClass} from '../../shared/services/add-remove-modal-class';

export const updateLaborAdditiveSummaryModalVisibility = isVisible =>

    dispatch => {

        addRemoveModalClass(isVisible);

        dispatch({
            isVisible,
            type: actions.UPDATE_HOME_PAGE_LABOR_ADDITIVE_SUMMARY_MODAL_VISIBILITY
        });

    };



// WEBPACK FOOTER //
// ./src/home-page/action-creators/labor-additive-summary-modal-visibility.js